import { htmlSafe } from '@ember/template';
import LinkifyIt from 'linkify-it';
import he from 'he';

const linkify = new LinkifyIt();

export function decodeText(str) {
  if (!str) return '';

  return he.decode(str);
}

export function decodeTextWithLinks(str) {
  if (!str) return '';

  let decodedText = he.decode(str);
  let matches = linkify.match(decodedText);

  let linkedText;
  if (!matches) {
    linkedText = he.encode(decodedText);
  } else {
    let result = '';
    let lastIndex = 0;

    // Emit encoded text up to each match's index, then wrap that URL in an <a> tag and continue.
    for (let match of matches) {
      result += he.encode(decodedText.slice(lastIndex, match.index));
      let href = he.encode(match.url);
      let text = he.encode(match.text);
      result += `<a href="${href}" target="_blank" rel="noopener noreferrer">${text}</a>`;
      lastIndex = match.lastIndex;
    }

    result += he.encode(decodedText.slice(lastIndex));
    linkedText = result;
  }

  return htmlSafe(linkedText.replace(/\n/g, '<br>'));
}
